import { useState, useCallback } from 'react';
import { hubspotAPI } from '../../services/api';

/**
 * useHubspotAdmin - Encapsulates HubSpot integration admin state and actions.
 * Returns { state, actions } to be spread into AdminContext value.
 */
export const useHubspotAdmin = () => {
  const [hubspotStatus, setHubspotStatus] = useState(null);
  const [hubspotLoading, setHubspotLoading] = useState(false);
  const [hubspotTestResult, setHubspotTestResult] = useState(null);

  const fetchHubspotStatus = useCallback(async () => {
    try {
      const status = await hubspotAPI.getStatus();
      setHubspotStatus(status);
    } catch (error) {
      console.error('Failed to fetch HubSpot status:', error);
      setHubspotStatus({ configured: false, connected: false, message: 'Kon status niet ophalen' });
    }
  }, []);

  const createHubspotProperties = useCallback(async () => {
    setHubspotLoading(true);
    try {
      const result = await hubspotAPI.createProperties();
      setHubspotTestResult(result);
      await fetchHubspotStatus();
    } catch (error) {
      console.error('Failed to create HubSpot properties:', error);
      setHubspotTestResult({ success: false, message: 'Fout bij aanmaken properties' });
    } finally {
      setHubspotLoading(false);
    }
  }, [fetchHubspotStatus]);

  const testHubspotSync = useCallback(async () => {
    setHubspotLoading(true);
    setHubspotTestResult(null);
    try {
      const result = await hubspotAPI.testSync();
      setHubspotTestResult(result);
    } catch (error) {
      console.error('HubSpot test failed:', error);
      setHubspotTestResult({ success: false, message: 'Test mislukt: ' + (error.response?.data?.detail || error.message) });
    } finally {
      setHubspotLoading(false);
    }
  }, []);

  return {
    hubspotStatus,
    hubspotLoading,
    hubspotTestResult,
    fetchHubspotStatus,
    createHubspotProperties,
    testHubspotSync,
  };
};
